module.exports = __webpack_public_path__ + "static/img/green tick.d346d54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/green tick.png
// module id = 2n4Y
// module chunks = 1